import { Segmented, Row, Col } from 'antd';
import React, { useState } from 'react';
import useAuthUser from 'src/hooks/useAuthUser';
import MessengerPreview from 'src/components/MessengerPreview';
import ReactMarkdown from 'react-markdown';
import { chatgenieAPI } from 'src/config/api';
import { useQuery } from 'react-query';
import queryKeys from 'src/constants/queryKeys';
import { Aside } from '../style';
import MessengerChat from '../../CopilotTestChat/MessengerChat';

const tabValues = ['Emulator', 'Full experience'];
const suggestions = ['I need help', 'Reset my password', 'New software request'];

export default function AgentEmulator() {
  const { company } = useAuthUser();
  const [sessionId, setSessionId] = useState(null);
  const [tabValue, setTabValue] = useState(tabValues[0]);
  const { data: designSettings, isLoading } = useQuery([queryKeys.GET_MESSENGER_DESIGN], () =>
    chatgenieAPI.getMessengerDesign()
  );

  const botName = designSettings?.bot_name || 'Magic Agent';
  const botAvatar = designSettings?.bot_icon?.path;

  const handleSendMessage = async ({ message }, cancelToken) => {
    return chatgenieAPI.emulateAgent(
      {
        message,
        thread_id: sessionId
      },
      cancelToken
    );
  };

  const formatAgentAction = (intentName, intentArguments) => {
    const argumentsFormatted = Object.entries(intentArguments)
      .map(([key, value]) => `- **${key}**: ${value}\n`)
      .join('');

    return `The contact has requested to perform the following action:
            \n**${intentName}**
            \nwith the following arguments:
            \n${argumentsFormatted}`;
  };

  const onAgentResponse = ({ data }) => {
    if (!sessionId) {
      setSessionId(data.thread_id);
    }
    const messages = [
      {
        type: 'copilot',
        avatar: botAvatar,
        name: botName,
        body: <ReactMarkdown>{data.message}</ReactMarkdown>
      }
    ];

    let intentName = null;
    if (data.action === 'internal_action_generic_tool') {
      intentName = 'Master Intent';
    } else if (!data.action.startsWith('internal')) {
      intentName = data.action;
    }

    if (intentName) {
      messages.push({
        type: 'copilot',
        avatar: botAvatar,
        name: botName,
        internal: true,
        body: <ReactMarkdown>{formatAgentAction(intentName, data.arguments)}</ReactMarkdown>
      });
    }

    return messages;
  };

  return (
    <Aside>
      <Row align="middle" justify="center" gutter={[10, 16]}>
        <Col span={24}>
          <Segmented options={tabValues} value={tabValue} onChange={setTabValue} block />
        </Col>
        <Col hidden={tabValue !== tabValues[0]}>
          <MessengerChat
            firstMessage="Hi there! Magic Agents here, type out any request or select one of the suggestions and I will give you a response!"
            messageAuthor={botName}
            messageAvatarUrl={botAvatar}
            placeholder="Message Magic Agents"
            onSend={handleSendMessage}
            newMessageNormalizer={onAgentResponse}
            shouldPromptForAnotherQuestion={false}
            suggestions={suggestions}
            isAnimating={isLoading}
            showClearButton
            onClear={() => setSessionId(null)}
            style={{
              width: 350,
              height: 'min(65vh, 600px)'
            }}
          />
        </Col>
        <Col span={24} hidden={tabValue !== tabValues[1]}>
          <MessengerPreview appId={company.appId} enabledDataPassing={false} />
        </Col>
      </Row>
    </Aside>
  );
}
